// extracted by mini-css-extract-plugin
module.exports = {"playButton":"_35sXjm","svg":"_-7SXA7","circle":"_2OEFAv","triangle":"wBJ4iC","playbackAction":"_3r1hq1","playbackLabel":"_2PKmFk"};